export const ENTITY_TYPE_OPTIONS = [
	{ value: "corporation", label: "Corporation" },
	{ value: "sole_prop", label: "Sole Proprietorship" },
	{ value: "partnership", label: "Partnership" },
	{ value: "trust", label: "Trust" },
	{ value: "nonprofit", label: "Non-profit" },
];

export const OPERATING_PROFILE_OPTIONS = [
	{ value: "service", label: "Service Business" },
	{ value: "inventory", label: "Inventory / Retail" },
	{ value: "holdco", label: "Holding Company" },
	{ value: "mixed", label: "Mixed" },
];
